import { Charts } from 'modules'

import { constant } from './resizable-editor.constant'
import { resizableEditorSelectors } from './resizable-editor.selector'

export const resizableEditorComponent = (() => {
	const saveInitialRatio = (ratio: number) => {
		try {
			localStorage.setItem(constant.storage.editorMenuContentWidthRatio, ratio.toString())
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error('Missing local storage')
		}
	}

	const resizeContent = (contentWrapper: HTMLElement, width: number) => {
		contentWrapper.style.paddingLeft = `${width}px`
	}

	const resizeContainers = (asides: NodeListOf<HTMLElement>, size: number) => {
		const sizeInPx = `${size}px`
		for (let i = 0; i < asides.length; i++) {
			const aside = asides[i]
			if (aside.offsetWidth === size) {
				return
			}
			aside.style.width = sizeInPx
		}
	}

	const addEventListeners = (splitters: NodeListOf<HTMLElement>, resize: (e: MouseEvent) => void) => {
		for (let i = 0; i < splitters.length; i++) {
			const contentSplitter = splitters[i]

			contentSplitter.addEventListener('mousedown', () => {
				document.addEventListener('mousemove', resize, false)
				document.addEventListener(
					'mouseup',
					() => {
						document.removeEventListener('mousemove', resize, false)
						Charts.update()
					},
					false,
				)
			})
		}
	}

	const setUpResizing = (initialWidthRatio: number | null) => {
		const asideWrappers = resizableEditorSelectors.getAsides()
		const contentWrapper = resizableEditorSelectors.getContent()
		const contentSplitters = resizableEditorSelectors.getSplitters()

		if (asideWrappers.length === 0 || !contentWrapper || contentSplitters.length === 0) {
			return
		}

		const resize = (widthRatio: number) => {
			const contentWidth = widthRatio / (widthRatio + 1)
			const menuWidth = 1.0 - contentWidth

			const maxWidth = getMaxWidth()
			const width = maxWidth * menuWidth

			resizeContainers(asideWrappers, width)
			resizeContent(contentWrapper, width + (window.innerWidth - maxWidth))
			saveInitialRatio(widthRatio)
		}

		const handleResize = (e: MouseEvent) => {
			e.preventDefault()
			const totalWidth = getMaxWidth()
			const menuWidth = e.x - document.body.scrollWidth * 0.08
			const contentWidth = totalWidth - menuWidth

			resize(contentWidth / menuWidth)
		}

		addEventListeners(contentSplitters, handleResize)

		if (initialWidthRatio !== null) {
			resize(initialWidthRatio)
		}
	}

	const getMaxWidth = () => {
		const categoriesContainer = document.getElementById(constant.selector.categoriesContainer) as HTMLElement
		const bounds = categoriesContainer.getBoundingClientRect()

		return window.innerWidth - bounds.width
	}

	const getInitialWidthRatio = () => {
		try {
			const initialEditorMenuWidth = localStorage.getItem('initialEditorMenuWidth')
			const initialEditorContentWidth = localStorage.getItem('initialEditorContentWidth')

			if (initialEditorMenuWidth !== null && initialEditorContentWidth !== null) {
				localStorage.removeItem('initialEditorMenuWidth')
				localStorage.removeItem('initialEditorContentWidth')
				return parseFloat(initialEditorContentWidth) / parseFloat(initialEditorMenuWidth)
			}

			const initialWidthRatio = localStorage.getItem(constant.storage.editorMenuContentWidthRatio)

			if (initialWidthRatio !== null) {
				return parseFloat(initialWidthRatio)
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error('Missing local storage')
		}
		return null
	}

	const init = () => {
		setUpResizing(getInitialWidthRatio())
	}

	return {
		init,
	}
})()
